<ng-container *ngIf="leadOrder.length > 0; else noOrderProducts">
  <div class="grid grid-flow-row gap-2">
    <ng-container *ngFor="let item of leadOrder">
      <ng-container *ngIf="itemId !== item.id; else productFieldTemplate">
        <div
          class="w-full box-border p-3 bg-neutrals-0 border-neutrals-300 rounded-[8px] flex flex-row gap-3"
        >
          <unicon-product-option-chip
            class="flex-none min-w-[70px]"
            [product]="{
              businessLineName: item.businessLineName,
              quantity: item.quantity,
            }"
          />

          <div class="flex justify-between w-full gap-4">
            <div class="flex flex-col flex-1 mr-2 min-w-0 overflow-hidden">
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                font-weight="semibold"
                text-color="neutrals-900"
                class="break-all"
              >
                {{
                  item.productVariantName
                    ? item.productVariantName
                    : 'No especificado'
                }}
              </ui-paragraph>
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                font-weight="regular"
                text-color="neutrals-900"
                class="break-all"
              >
                {{ item.quantity }}
              </ui-paragraph>
            </div>

            <div class="flex-none">
              <button
                class="bg-neutrals-200 p-2 rounded-[8px] hover:shadow-lg"
                [matMenuTriggerFor]="orderItemMenu"
              >
                <ui-icon
                  name="vertical-menu"
                  size="16"
                  m-size="16"
                  fill="neutrals-900"
                />
              </button>

              <mat-menu #orderItemMenu="matMenu" class="bg-white">
                <div class="grid grid-flow-row w-[172px] box-border">
                  <button
                    mat-menu-item
                    class="flex flex-row justify-start items-center gap-2"
                    (click)="onUpdate(item.id)"
                    [disabled]="!isActivated"
                  >
                    <ui-icon
                      class="inline-flex flex-none mr-2"
                      name="edit"
                      fill="neutrals-600"
                      size="16"
                      mSize="16"
                    />
                    <ui-paragraph
                      class="inline-flex flex-grow"
                      class="capitalize"
                      type="p12"
                      mobile-type="p12"
                      text-color="neutrals-900"
                      font-weight="regular"
                    >
                      Editar
                    </ui-paragraph>
                  </button>

                  <button
                    mat-menu-item
                    class="flex flex-row justify-start items-center gap-2"
                    (click)="delete.emit(item.id)"
                    [disabled]="!isActivated"
                  >
                    <ui-icon
                      class="inline-flex flex-none mr-2"
                      name="delete"
                      fill="neutrals-600"
                      size="16"
                      mSize="16"
                    />
                    <ui-paragraph
                      class="inline-flex flex-grow"
                      type="p12"
                      mobile-type="p12"
                      text-color="neutrals-900"
                      font-weight="regular"
                    >
                      Eliminar
                    </ui-paragraph>
                  </button>
                </div>
              </mat-menu>
            </div>
          </div>

          <!--  <div class="flex flex-col max-w-[80px]">
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              font-weight="semibold"
              text-color="neutrals-900"
              class="break-words"
            >
              {{
                item.productVariantName
                  ? item.productVariantName
                  : 'No especificado'
              }}
            </ui-paragraph>
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              font-weight="regular"
              text-color="neutrals-900"
              class="break-words"
            >
              {{ item.quantity }}
            </ui-paragraph>
          </div>

          <div class="flex-none">
            <button
              class="bg-neutrals-200 p-2 rounded-[8px] hover:shadow-lg"
              [matMenuTriggerFor]="orderItemMenu"
            >
              <ui-icon
                name="vertical-menu"
                size="16"
                m-size="16"
                fill="neutrals-900"
              />
            </button>

            <mat-menu #orderItemMenu="matMenu" class="bg-white">
              <div class="grid grid-flow-row w-[172px] box-border">
                <button
                  mat-menu-item
                  class="flex flex-row justify-start items-center gap-2"
                  (click)="onUpdate(item.id)"
                  [disabled]="!isActivated"
                >
                  <ui-icon
                    class="inline-flex flex-none mr-2"
                    name="edit"
                    fill="neutrals-600"
                    size="16"
                    mSize="16"
                  />
                  <ui-paragraph
                    class="inline-flex flex-grow"
                    class="capitalize"
                    type="p12"
                    mobile-type="p12"
                    text-color="neutrals-900"
                    font-weight="regular"
                  >
                    Editar
                  </ui-paragraph>
                </button>

                <button
                  mat-menu-item
                  class="flex flex-row justify-start items-center gap-2"
                  (click)="delete.emit(item.id)"
                  [disabled]="!isActivated"
                >
                  <ui-icon
                    class="inline-flex flex-none mr-2"
                    name="delete"
                    fill="neutrals-600"
                    size="16"
                    mSize="16"
                  />
                  <ui-paragraph
                    class="inline-flex flex-grow"
                    type="p12"
                    mobile-type="p12"
                    text-color="neutrals-900"
                    font-weight="regular"
                  >
                    Eliminar
                  </ui-paragraph>
                </button>
              </div>
            </mat-menu>
          </div> -->
        </div>
      </ng-container>

      <ng-template #productFieldTemplate>
        <unicon-product-field
          *ngIf="itemId === item.id"
          [initialValues]="{
            businessLineId: item.businessLineId,
            productId: item.productId ? item.productId : '',
            productVariantId: item.productVariantId
              ? item.productVariantId
              : '',
            quantity: item.quantity,
            productVariantName: item.productVariantName,
            mixingCode: item.mixingCode,
          }"
          (cancel)="onUpdate('')"
          (result)="onEditResult($event, item.id)"
          [verticalContainer]="true"
        />
      </ng-template>
    </ng-container>
  </div>
</ng-container>

<ng-template #noOrderProducts>
  <div
    class="box-border px-4 py-3 bg-neutrals-0 border-neutrals-300 rounded-[8px]"
  >
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      font-weight="regular"
      text-color="neutrals-700"
    >
      Todavía no se ha agregado ningún producto.
    </ui-paragraph>
  </div>
</ng-template>
